import React, { useState, useEffect } from 'react';
import { Helmet } from 'react-helmet-async';
import { Link } from 'react-router-dom';
import Header from '../components/Header';
import Footer from '../components/Footer';
import { campaignsAPI } from '../api';
import { Card } from '../components/ui/card';
import { Button } from '../components/ui/button';
import { ArrowRight } from 'lucide-react';
import { useSettings } from '../contexts/SettingsContext';
import { usePageTitle } from '../hooks/usePageTitle';

const Campaigns = () => {
  const { settings } = useSettings();
  const [campaigns, setCampaigns] = useState([]);
  const [loading, setLoading] = useState(true);
  
  // Ensure title updates immediately
  usePageTitle('Kampanyalar');

  useEffect(() => {
    loadCampaigns();
  }, []);

  const loadCampaigns = async () => {
    try {
      const response = await campaignsAPI.getAll();
      setCampaigns(response.data.filter(c => c.is_active));
    } catch (error) {
      console.error('Error loading campaigns:', error);
    } finally {
      setLoading(false);
    }
  };

  return (
    <div className="min-h-screen bg-[#0a0a0a]">
      <Helmet>
        <title>Kampanyalar - {settings.site_name || 'Cinefora'}</title>
        <meta name="description" content="Cinefora'nın özel kampanyaları ve indirimlerinden yararlanın. Sinema biletlerinde avantajlı fırsatlar." />
        <meta name="keywords" content="kampanya, indirim, fırsat, sinema bileti, cinefora" />
      </Helmet>
      <Header />
      <div className="container mx-auto px-6 py-32">
        <h1 className="text-4xl font-bold text-white mb-8">Kampanyalar</h1>
        
        {loading ? (
          <p className="text-white text-center">Yükleniyor...</p>
        ) : campaigns.length === 0 ? (
          <p className="text-gray-400 text-center">Henüz aktif kampanya bulunmamaktadır.</p>
        ) : (
          <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-3 gap-6">
            {campaigns.map((campaign) => (
              <Card key={campaign._id} className="bg-gradient-to-br from-purple-500/20 to-pink-500/20 border-purple-500/30 overflow-hidden hover:border-pink-500/50 hover:from-purple-500/30 hover:to-pink-500/30 transition-all">
                <Link to={campaign.slug ? `/kampanyalar/${campaign.slug}` : '#'}>
                  <img src={campaign.image} alt={campaign.title} className="w-full h-48 object-cover cursor-pointer hover:opacity-90 transition-opacity" />
                </Link>
                <div className="p-6">
                  <Link to={campaign.slug ? `/kampanyalar/${campaign.slug}` : '#'}>
                    <h3 className="text-white font-bold text-xl mb-3 hover:text-[#FDB714] transition-colors cursor-pointer">{campaign.title}</h3>
                  </Link>
                  <p className="text-gray-400 mb-4 line-clamp-3">{campaign.description}</p>
                  <div className="flex justify-between items-center">
                    <div className="text-sm text-gray-500">
                      {campaign.start_date} - {campaign.end_date}
                    </div>
                    {campaign.slug && (
                      <Link to={`/kampanyalar/${campaign.slug}`}>
                        <Button 
                          variant="ghost" 
                          size="sm"
                          className="text-[#FDB714] hover:text-white hover:bg-[#FDB714] transition-colors"
                        >
                          Devamını Oku
                          <ArrowRight size={16} className="ml-2" />
                        </Button>
                      </Link>
                    )}
                  </div>
                </div>
              </Card>
            ))}
          </div>
        )}
      </div>
      <Footer />
    </div>
  );
};

export default Campaigns;
